import * as React from 'react';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { useSelector } from 'react-redux';
import { Search } from '@mui/icons-material';
import { IconButton, TextField } from '@mui/material';
import "../Styles/AdminListings.css";
import { maskedAccountId } from '../../common/Utils';

function not(a, b) {
  return a.filter((value) => !b.some((item)=> item.id === value.id));
}

function intersection(a, b) {
  return a.filter((value) => b.some((item) => item.id === value.id));
}

export default function TransferListOfChild(props) {
  const {carefacilityList, setSelectedCompanies, setRightListCount, 
    setTransferListError, right, setRight, left, setLeft, checked, 
    setChecked, sortInAlphabeticalOrder, searchText, setSearchText} = props;
  

  const storeToken = useSelector((state)=> state.storetoken);
  const [showTextField, setShowTextField] = React.useState(false);
  
  React.useEffect(() => {
    setRightListCount(right.length);
    setSelectedCompanies(right);
    if(right.length >1){
      setTransferListError({});
    }    
  }, [right, setRightListCount]);

  React.useEffect( () => {
    setLeft(carefacilityList);
}, [storeToken, carefacilityList]);

  React.useEffect(() => {
    setLeft(sortInAlphabeticalOrder(left));
  },[left]);

  

  const handleToggle = (value) => () => {
    const currentIndex = checked.findIndex((item)=> item.id === value.id);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    const selected = intersection(checked, items);
    if (selected.length === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked([...checked, ...not(items, checked)]);
    }
  };

  const handleTransferRight = () => {
    const selected = intersection(checked, left);
    setRight([...right, ...selected]);
    setLeft(not(left, selected));
    setChecked(not(checked, selected)); 
  };

  const handleTransferLeft = () => {
    const selected = intersection(checked, right);
    setLeft([...left, ...selected]);
    setRight(not(right, selected));
    setChecked(not(checked, selected));  
  };

  const handleSearchClick=()=>{
    setShowTextField(!showTextField);
  }

  return (     
    <Grid
      container
      spacing={1}
      sx={{ justifyContent: 'center', alignItems: 'center' }}
    >
      <Grid item>
        {/* {customList(left)} */}
        <TransferListCard
        items={left}
        checked={checked}
        handleToggle={handleToggle}
        handleToggleAll={handleToggleAll}
        numberOfChecked={numberOfChecked}
        handleSearchClick={handleSearchClick}
        showTextField={showTextField}
        setShowTextField={setShowTextField}
        searchText={searchText}
        setSearchText={setSearchText}
        //handleChangeSearchText={handleChangeSearchText}
        isLeft/>
      </Grid>
      <Grid item>
        <Grid container direction="column" sx={{ alignItems: 'center' }}>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleTransferRight}
            disabled={intersection(checked, left).length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleTransferLeft}
            disabled={intersection(checked, right).length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        {/* {customList(right)} */}
        <TransferListCard
        items={right}
        checked={checked}
        handleToggle={handleToggle}
        handleToggleAll={handleToggleAll}
        numberOfChecked={numberOfChecked}
        isLeft={false}/>
      </Grid>
    </Grid>
  );
}


const TransferListCard = ({
  items,
  title,
  checked,
  handleToggle,
  handleToggleAll,
  numberOfChecked,
  handleSearchClick,
  showTextField,
  handleChangeSearchText,
  searchText,
  setSearchText,
  isLeft=false

})=>{

  const filteredItems = isLeft ?
  items.filter(item =>
    item.companyName.toLowerCase().includes(searchText.toLowerCase()) ||
    item.accountNumber.includes(searchText)
  ): items;

  return (
    <div>
      <Card 
    sx={{
      border: "1.5px solid #dfe3e8",
      minHeight: "420px", 
      height:"420px", 
      boxShadow: "none"
    }}
    //style={{minHeight: "420px", height:"420px"}} 
      >
      <CardHeader
        //sx={{ px: 2, py: 1 ,"& .MuiCardHeader-root":{padding: "8px 6px"}}}
        sx={{ px: 2, py: 1}}
        style={{padding: "1px 3px"}}
        avatar={
          <Checkbox
           sx={{mr:"1px !important"}}
            onClick={handleToggleAll(items)}

            checked={
                //intersection(checked, items).length === items.length && items.length!==0}
                numberOfChecked(items)=== items.length && items.length!==0
            }
            indeterminate={
              //intersection(checked, items).length > 0 && intersection(checked, items).length <items.length
              numberOfChecked(items) >0 &&
              numberOfChecked(items) < items.length
            }
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
            style={{marginRight:"1px"}}
          />
        }
        //title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
        action={ isLeft ?
          <IconButton  sx={{mt:"4px", mr:"3px"}} onClick={handleSearchClick}>
             <Search/>
          </IconButton> :""
        }
        
      />
      {showTextField && isLeft && (
      <TextField
      className='search-text'
      size='small'
      placeholder='Search...'
      variant="standard"
      value={searchText}
      //onChange={(e) =>handleChangeSearchText(e, items)}
      onChange={e => setSearchText(e.target.value)}
      sx={{mx:2, mb:1}}
      />)}
      <Divider />
      <List
        sx={{
          width: 220,
          minHeight: "350px",
          height: "350px",
          maxHeight:"350px",
          bgcolor: 'background.paper',
          overflow: 'auto',
        }}
        dense
        component="div"
        role="list"
      >
        {filteredItems.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <div>
            <ListItemButton style={{paddingLeft:"3px", paddingRight:"3px"}}
            disablePadding={true}
            //sx={{"& .MuiButtonBase-root":{paddingLeft:"3px", paddingRight:"3px"}}}
              key={value}
              role="listitem"
              onClick={handleToggle(value)}
            >
              <ListItemIcon style={{minWidth: "1px"}}>
                <Checkbox
                  checked={checked.some((item)=> item.id === value.id)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.companyName} />
              </ListItemButton>
              <div><p style={{marginLeft:"40px"}}>{searchText ? "("+maskedAccountId(value.accountNumber)+")":""}</p></div>
              </div>
          );
        })}
      </List>
    </Card>
    </div>
  )
}




